// anima_core#24 (03.11.2026): changing one's own password - in the password
// change or through the user form - ends every session of the account. The
// hub answers with a fresh token for the session that made the change; this
// one keeps working with it instead of being signed out on the next request.
// (The spoke frontend has the same since Core#61.)

/**
 * The renewed token in an answer of POST api/Users/Passwortwechsel or
 * PUT api/Users/{id}, or null when there is none. Total: anything that is
 * not an object with a non-empty string "token" gives null.
 */
export const renewedToken = (payload: unknown): string | null => {
    if (typeof payload !== "object" || payload === null) {
        return null;
    }
    const token = (payload as { token?: unknown }).token;
    return typeof token === "string" && token.length > 0 ? token : null;
};
